

// Функция для преобразования строки в массив чисел
export const stringToArray = (str) => {
    if (!str || typeof str !== 'string') {
        return [];
    }
    return str.split(',')
        .map(item => item.trim())
        .filter(item => item !== '')
        .map(item => {
            const num = parseInt(item, 10);
            return isNaN(num) ? null : num;
        })
        .filter(item => item !== null);
};